import React from "react";

const steps = [
  {
    title: "Register as a supply partner",
    detail:
      "Getting started is easy. We’ll ask for some simple contact and company details, such as which travel experiences your business offers",
  },
  {
    title: "Share your business details",
    detail:
      "From there, you’ll fill out your key legal and financial information",
  },
  {
    title: "Add your first activity",
    detail:
      "Create and upload your first product listing with your content, availability, and reservation system connection",
  },
];

function HomeStartSellingSection() {
  return (
    <div className={Classname.container}>
      <div className={Classname.content}>
        <span className="font-bold text-2xl lg:text-4xl mb-10 text-center">
          Start selling your activity in 30 minutes
        </span>

        <div className="w-full gap-4 flex flex-col lg:flex-row justify-between mb-10">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-[#EBEFF959] flex flex-col flex-1 rounded-md py-10 px-6"
            >
              <div className="text-white font-bold text-sm lg:text-base w-10 h-10 rounded-full bg-primary flex items-center justify-center mb-4">
                {index + 1}
              </div>
              <span className="font-bold text-lg lg:text-xl mb-4 max-w-56">
                {step.title}
              </span>
              <p className="text-sm lg:text-base">{step.detail}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HomeStartSellingSection;

const Classname = {
  container:
    "w-full flex justify-center pt-20 px-basicx xl:px-0 font-main relative",
  content: "w-full flex flex-col max-w-7xl px-2 xl:px-0 items-center",
  title:
    "text-primary text-lg lg:text-xl font-bold  text-center lg:text-start max-w-56",
  description: "text-sm lg:text-base text-center lg:text-start",
  why: "flex flex-1 flex-col gap-4 items-center lg:items-start",
};
